import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AgeingSearch = () => {
  const [days, setDays] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    const value = parseInt(days);

    if (!value || value <= 0) {
      alert("Please enter a valid number of days");
      return;
    }

    navigate(`/AgeingResults/${days}`);
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>📆 Ageing Search</h2>
        <p style={styles.subtitle}>
          Select or manually enter number of days
        </p>

        {/* Manual Input */}
        <div style={styles.group}>
          <label style={styles.label}>Enter Days</label>
          <input
            type="number"
            min="1"
            max="365"
            placeholder="Type days (e.g., 30, 90, 120)"
            value={days}
            onChange={(e) => setDays(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.orText}>OR</div>

        {/* Dropdown */}
        <div style={styles.group}>
          <label style={styles.label}>Select Days</label>
          <select
            value={days}
            onChange={(e) => setDays(e.target.value)}
            style={styles.select}
          >
            <option value="">-- Select Days --</option>
            {[...Array(365)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1} Days
              </option>
            ))}
          </select>
        </div>

        <button style={styles.button} onClick={handleSearch}>
          🔍 Search
        </button>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #eef2ff, #f8fafc)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "100%",
    maxWidth: "480px",
    background: "#fff",
    padding: "35px",
    borderRadius: "20px",
    boxShadow: "0 25px 50px rgba(0,0,0,0.1)",
  },
  title: {
    textAlign: "center",
    fontSize: "24px",
    fontWeight: "700",
    color: "#1f2937",
  },
  subtitle: {
    textAlign: "center",
    fontSize: "14px",
    color: "#6b7280",
    marginBottom: "20px",
  },
  group: { marginBottom: "15px" },
  label: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#374151",
    marginBottom: "6px",
    display: "block",
  },
  input: {
    width: "100%",
    padding: "14px",
    fontSize: "15px",
    border: "2px solid #c7d2fe",
    borderRadius: "12px",
  },
  select: {
    width: "100%",
    padding: "14px",
    fontSize: "15px",
    border: "2px solid #c7d2fe",
    borderRadius: "12px",
  },
  orText: {
    textAlign: "center",
    margin: "10px 0",
    fontSize: "13px",
    fontWeight: "600",
    color: "#9ca3af",
  },
  button: {
    width: "100%",
    marginTop: "10px",
    padding: "14px",
    fontSize: "16px",
    fontWeight: "600",
    color: "#fff",
    background: "linear-gradient(135deg, #2563eb, #4f46e5)",
    border: "none",
    borderRadius: "14px",
    cursor: "pointer",
    boxShadow: "0 10px 20px rgba(37,99,235,0.4)",
  },
};

export default AgeingSearch;
